import { render } from "./signed-document-successful.vue?vue&type=template&id=ee2b3608&scoped=true"
const script = {}

import "./signed-document-successful.vue?vue&type=style&index=0&id=ee2b3608&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee2b3608"]])

export default __exports__